// Keeps a window on its airline (see pinnedBrand.js). Signed out: any sign-in page goes to the
// pinned airline's version. Signed in as someone who does not belong to that airline (e.g. a
// session from another airline's tab, which shares storage): sign out, back to its sign-in page.
import React from 'react'
import PropTypes from 'prop-types'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import { normaliseCode } from './brandStorage'
import { authBelongsTo, pinnedAuthPath, pinnedBrandCode } from './pinnedBrand'

export const signOutTo = (code) => `/logout?brand=${code}&notice=other_airline`

const PinnedBrandGuard = ({ auth }) => {
  const location = useLocation()
  const pinned = pinnedBrandCode()
  if (!pinned) return null

  if (auth) {
    if (location.pathname === '/logout' || authBelongsTo(auth, pinned)) return null
    return <Navigate replace to={signOutTo(pinned)} />
  }

  const target = pinnedAuthPath(location.pathname, pinned)
  return target ? <Navigate replace to={`${target}${location.search}`} /> : null
}

PinnedBrandGuard.propTypes = { auth: PropTypes.object }

/**
 * /login/<code> while signed in: the dashboard if the session belongs to that airline,
 * otherwise sign out and show that airline's sign-in page.
 */
export const SignedInBrandedLogin = ({ auth }) => {
  const code = normaliseCode(useParams().code)
  if (!code || authBelongsTo(auth, code)) return <Navigate replace to="/" />
  return <Navigate replace to={signOutTo(code)} />
}

SignedInBrandedLogin.propTypes = { auth: PropTypes.object }

export default PinnedBrandGuard
